import { render, staticRenderFns } from "./package_confirm.vue?vue&type=template&id=e4ae3dda&scoped=true&"
import script from "./package_confirm.vue?vue&type=script&lang=js&"
export * from "./package_confirm.vue?vue&type=script&lang=js&"
import style0 from "./package_confirm.vue?vue&type=style&index=0&id=e4ae3dda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4ae3dda",
  null
  
)

export default component.exports